import React from "react";
import { Alert, Modal } from "react-bootstrap";
import _Input from "../../../generic/_Input";
import PropTypes from "prop-types";
import { useFormik } from "formik";
import { useMutation } from "@tanstack/react-query";
import * as Yup from "yup";
import { httpClient } from "../../../../utils/HttpClient";
import { ApiEndpoint } from "../../../../utils/ApiEndpoint";
import { useAuth } from "../../../../Context/AuthContext";
import { ErrorMessage, SuccessMessage } from "../../../../utils/toastify";
import { errorLabels } from "../../../../utils/helpers";
import _Button from "../../../generic/_Button";
const _ModalAddDeviceTestRCSAgent = (props) => {
  const { visible, onClose, title, refetch, data } = props;
  const auth = useAuth();
  const { token } = auth.getSessionData();
  const formik = useFormik({
    initialValues: {
      phoneNumber: "",
    },
    validationSchema: Yup.object({
      phoneNumber: Yup.string()
        .matches(/^[0-9]{10}$/, "El número de teléfono debe tener 10 dígitos")
        .required("El número de teléfono es requerido"),
    }),
    validateOnChange: true,
    onSubmit: async (values) => {
      await sendInvitation(values);
    },
  });

  const { mutate: sendInvitation, isPending: isLoading } = useMutation({
    mutationFn: async (values) => {
      const response = await httpClient(
        "POST",
        `${ApiEndpoint}rcs/invitetester`,
        {
          phone: values.phoneNumber,
          agentId: data.vcPartner
        },
        token,
      );

      return await response.data;
    },
    onSuccess: () => {
      formik.resetForm();
      _onClose();
      refetch();
      SuccessMessage("Invitación enviada correctamente");
    },
    onError: (error) => {
      console.log(error);
      ErrorMessage("Error al enviar la invitación: " + error.message);
    },
  });

  const _onClose = () => {
    if (onClose) onClose();
  };
  const _validate = async () => {
    try {
      const isValid = await formik.validateForm();
      const errors = errorLabels(isValid);

      if (Object.keys(isValid).length !== 0) {
        throw new Error(`Campos inválidos: ${errors}`);
      }
      await formik.submitForm();
    } catch (error) {
      ErrorMessage(error.message);
    }
  };

  return (
    <Modal show={visible} onHide={_onClose} centered size="md">
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Alert variant="secondary">
        <p className="text-sm">
            Se enviará una invitación al número de teléfono proporcionado para que pueda probar el agente RCS. Asegúrate de que el número sea correcto y esté registrado en un dispositivo compatible con RCS.
        </p>
        </Alert>
        <_Input
          id="phoneNumber"
          name="phoneNumber"
          value={formik.values.phoneNumber}
          onChange={formik.handleChange}
          title={"Número de teléfono"}
          type="text"
          isError={formik.errors.phoneNumber ? true : false}
          errors={formik.errors.phoneNumber ? formik.errors.phoneNumber : ""}
          onBlur={formik.handleBlur}
          required
        />
      </Modal.Body>
      <Modal.Footer className="sticky bottom-0 bg-white">
        <_Button
          style="none"
          onClick={_onClose}
          disabled={isLoading}
          loading={isLoading}
          title="Cancelar"
        />

        <_Button
          style="primary"
          onClick={_validate}
          disabled={isLoading}
          loading={isLoading}
          title="Enviar"
        />
      </Modal.Footer>
    </Modal>
  );
};

_ModalAddDeviceTestRCSAgent.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  data: PropTypes.object,
  refetch: PropTypes.func,
};

export default _ModalAddDeviceTestRCSAgent;
